import { format } from 'date-fns'
import { FULL_DATE } from 'constants/dateFormats'

export function formatFullDate(date) {
  return format(date, FULL_DATE)
}
